export const drawerBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

export const sectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const sectionTitleStyles = {
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

export const summaryGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '2px',
  borderRadius: ({ shape }) => shape.radius.l,
  overflow: 'hidden',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.border.default,
};

export const summaryCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px 14px',
  backgroundColor: ({ palette }) => palette.background.primary,
};

export const netCellValueStyles = {
  color: 'success.main',
};

export const requestedByStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: 'text.secondary',
};

export const resultCellStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const overrideCellStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const documentsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const docChipStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '10px 12px',
  borderRadius: ({ shape }) => shape.radius.l,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.primary,
};

export const docChipMetaStyles = {
  flex: 1,
  minWidth: 0,
};

export const docChipIconStyles = {
  width: '30px',
  height: '30px',
  borderRadius: ({ shape }) => shape.radius.m,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 'none',
  color: 'error.main',
  backgroundColor: ({ palette }) => palette.error.soft,
};

export const footerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

export const footerSpacerStyles = {
  flex: 1,
};
